import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../styles/organisms/voteSectionBanner.module.scss';
import Mansion from 'assets/images/mansion.png';
import PwanSmall from 'assets/images/p-wan-small.png';
import { ReactComponent as GreenCircleArrow } from 'assets/images/green-circle-arrow.svg';

const VoteSectionBanner: React.FC = () => {
  return (
    <div className={styles.voteBanner}>
      <Link to="/survey" className={styles.voteBanner__link}>
        <div className={styles.voteBanner__container}>
          {/* スマホ用タイトル */}
          <h2 className={`${styles.voteBanner__title} ${styles.voteBanner__titleSp}`}>
            妄想マンション投票
            <span className={styles.voteBanner__badge}>
              第<span className={styles.voteBanner__number}>2</span>弾
            </span>
          </h2>

          {/* スマホ用画像 */}
          <div className={styles.voteBanner__buildingWrapperSp}>
            <img
              src={Mansion}
              alt="マンション"
              className={styles.voteBanner__buildingSp}
            />
          </div>

          <div className={styles.voteBanner__left}>
            <img
              src={Mansion}
              alt="マンション"
              className={styles.voteBanner__building}
            />
            {/* PC用タイトル */}
            <h2 className={`${styles.voteBanner__title} ${styles.voteBanner__titlePc}`}>
              妄想マンション投票
              <span className={styles.voteBanner__badge}>
                第<span className={styles.voteBanner__number}>2</span>弾
              </span>
            </h2>
          </div>

          <div className={styles.voteBanner__right}>
            <button className={styles.voteBanner__button}>
              <span className={styles.voteBanner__buttonText}>投票する</span>
              <GreenCircleArrow className={styles.voteBanner__buttonIcon} />
            </button>
          </div>

          <div className={styles.voteBanner__pwanWrapper}>
            <img
              src={PwanSmall}
              alt="P-wan"
              className={styles.voteBanner__pwan}
            />
          </div>
        </div>
      </Link>
    </div>
  );
};

export default VoteSectionBanner;